import { GetQueryParams, GetQueryResponse } from '../../../types/api.type';
import { FoodHistory } from '../../../types/content.type';
import { sfcApi } from '../../api';
export interface FoodHistoryCreateUpdateValues {
  id?: number;
  name: string;
  content: string;
  image?: File;
  image_source: string;
}
export const FoodHistoryApi = sfcApi.injectEndpoints({
  endpoints: (builder) => ({
    getFoodHistories: builder.query<GetQueryResponse, GetQueryParams | void>({
      query: (params) => ({
        url: `food-histories${params?.scope ? `?scope=${params.scope}` : ''}`,
        method: 'POST',
        body: params?.data
      }),
      providesTags: ['FoodHistories']
    }),
    getFoodHistory: builder.query<{ foodHistory: FoodHistory }, number>({
      query: (id) => `food-histories/${id}`
    }),

    createFoodHistory: builder.mutation<
      { foodHistory: FoodHistory },
      FoodHistoryCreateUpdateValues
    >({
      query: (data) => {
        const formData = new FormData();
        let payload: any = {
          url: `food-histories/create`,
          method: 'POST',
          body: data
        };
        Object.entries(data).forEach(([key, value]) => formData.append(key, value));
        if (data.image?.name) {
          payload.formData = true;
        }
        if (!data?.image?.name) {
          formData.delete('image');
        }
        payload.body = formData;

        return payload;
      },
      invalidatesTags: ['FoodHistories']
    }),

    updateFoodHistory: builder.mutation<
      { foodHistory: FoodHistory },
      FoodHistoryCreateUpdateValues
    >({
      query: (data) => {
        const { id } = data;
        delete data.id;
        const formData = new FormData();
        let payload: any = {
          url: `food-histories/update/${id}`,
          method: 'PUT',
          body: data
        };
        Object.entries(data).forEach(([key, value]) => formData.append(key, value));
        if (data.image?.name) {
          payload.formData = true;
        }
        if (!data?.image?.name) {
          formData.delete('image');
        }
        payload.body = formData;

        return payload;
      },
      invalidatesTags: ['FoodHistories']
    }),

    deleteFoodHistory: builder.mutation<{ foodHistory: FoodHistory }, number>({
      query: (id) => ({
        url: `food-histories/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['FoodHistories']
    })
  })
});

export const {
  useGetFoodHistoriesQuery,
  useGetFoodHistoryQuery,
  useCreateFoodHistoryMutation,
  useUpdateFoodHistoryMutation,
  useDeleteFoodHistoryMutation
} = FoodHistoryApi;
